export default __webpack_public_path__ + "static/media/featimgfour.18003c62.svg";